module.exports = __webpack_public_path__ + "cd7c5816d3daeca75b645aab97cb95ef.eot";


//////////////////
// WEBPACK FOOTER
// ./src/client/fonts/Interstate-Regular.eot
// module id = 967
// module chunks = 0